import { AbstractControl, Validator, ValidationErrors, NG_VALIDATORS, ValidatorFn, FormGroup } from "@angular/forms";
import { Directive } from "@angular/core";

@Directive({
  selector: '[appValidateDates]',
  providers: [{ provide: NG_VALIDATORS, useExisting: DatesValidatorDirective, multi: true }]
})

export class DatesValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return datesValidator(control);
  }
}


export const datesValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const startDateString = control.get('startDate');
  const endDateString = control.get('endDate');

  const startDate = new Date(control.get('startDate')?.value);
  const endDate = new Date(control.get('endDate')?.value);
  let x = startDateString?.valid && endDateString?.valid && startDate > endDate ? { datesInvalid: true } : null;
  return x;
};
